exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.flex {\n  -ms-flex-pack: start;\n      justify-content: flex-start; }\n\nli.flex:last-child {\n  -ms-flex-positive: 0.5;\n      flex-grow: 0.5; }\n\n.gap, .svg-icon {\n  margin: 15px 10px;\n  width: 50px; }\n\n.gap {\n  height: 42px; }\n  .gap i {\n    font-size: 24px; }\n\n@media (min-width: 320px) and (max-width: 480px) {\n  ul.flex.col-4 li.flex {\n    width: 100%; }\n    ul.flex.col-4 li.flex .block {\n      margin-top: 2px;\n      margin-bottom: 2px; }\n      ul.flex.col-4 li.flex .block .flex-container {\n        -ms-flex-pack: start;\n            justify-content: flex-start; }\n    ul.flex.col-4 li.flex .svg-icon {\n      width: 70px;\n      margin: 5px 10px !important; } }\n\n@media (min-width: 481px) and (max-width: 767px) {\n  ul.flex.col-4 li.flex {\n    width: 33.3%; } }\n\n@media (min-width: 768px) and (max-width: 1040px) {\n  ul.flex.col-4 li.flex > .block > .flex-container img.flex-item {\n    width: 66px;\n    margin: 5px 10px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/responsibility.component.scss
// module id = ../../../../../src/app/pages/responsibility.component.scss
// module chunks = main